import React, { useEffect } from 'react';
import * as AuthService from './AuthService';
import { ApplicationPaths } from './constants';
function Logout() {
    useEffect(function () {
        populateLogoutState();
    }, []);
    var populateLogoutState = function () {
        AuthService.signOut();
        location.href = "#" + ApplicationPaths.Login;
    };
    return (React.createElement("div", { className: "container" }, "loading..."));
}
export default Logout;
